import React from 'react';
import pt from 'prop-types';
import Themes from 'epic-react-search/app/scripts/constants/Themes';
import SearchView from 'epic-react-search/app/scripts/views/SearchView';
import styled from 'styled-components';
import {hot} from 'react-hot-loader';
import {useStore} from '../../stores';
import {ThemeProvider} from 'styled-components';
import {ueTheme, breakpointsInPx} from 'epic-ue-components';

const SearchWrap = styled.div`
    background-color: white;
    color: black;
`;

const SearchWrapper = ({location = {}}) => {
    const [{epicSearchFilter} = {}] = useStore();

    return (
        <SearchWrap>
            <ThemeProvider
                theme={{
                    ...ueTheme,
                    breakpoints: breakpointsInPx
                }}>
                <SearchView location={location} theme={Themes.LIGHT} enableCustomFilter={epicSearchFilter.enableCustomFilter} searchFilters={epicSearchFilter.searchFilters} />
            </ThemeProvider>
        </SearchWrap>
    );
};

SearchWrapper.propTypes = {
    location: pt.object
};

export default hot(module)(SearchWrapper);
